exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".conversation-item[data-v-0762e744]{border-bottom:1px solid hsla(0,0%,66.7%,.17)}.conversation-item.active[data-v-0762e744]{color:#0e0e0e;background-color:#e7e7e7;border-color:#e7e7e7}.conversation-item .details-group .last-message[data-v-0762e744]{font-size:14px;padding-top:8px}.conversation-item .end-group[data-v-0762e744]{padding-top:14px}", ""]);

// exports
